import sanitizeHtml from "sanitize-html";

export const parseHTML = (dirty: string): ReturnType<typeof sanitizeHtml> => {
  return sanitizeHtml(dirty, {
    allowedTags: ["b", "i", "br", "ul", "li"],
    selfClosing: ["br"],
  });
};
